import { Box, Typography, Stack } from '@mui/material';
import React from 'react';

import { EnlargedImage } from '@app/components/Shared/EnlargedImage';
import { theme } from '@app/theme';
import {
  ProductVariant,
  ProductVariantPlotMapCategory,
} from '@app/types/catalog';

interface PropertyPlotMapProps {
  variants: ProductVariant[];
}

export function PropertyPlotMap({ variants }: PropertyPlotMapProps) {
  return (
    <Box mt={3}>
      <Typography
        bgcolor={theme.palette.blueAccent.main}
        color="white"
        px={2}
        height={36}
        mt={5}
        fontWeight={600}
        borderRadius={15}
        display="flex"
        alignItems="center"
        variant="h6"
      >
        区画図
      </Typography>
      {variants.length > 0 && (
        <>
          {variants.map((variant, index) => (
            <Stack
              key={index}
              width="100%"
              bgcolor="white"
              mt={3}
              border="1px solid #E0E0E0"
              borderRadius={3}
              p={2}
            >
              <Box width="100%">
                {variant.images?.[0]?.url && (
                  <EnlargedImage
                    src={variant.images[0].url}
                    title={
                      Object.values(ProductVariantPlotMapCategory).find(
                        (category) =>
                          category.key === variant.customFields?.category
                      )?.label || ''
                    }
                    height="100%"
                    objectFit="contain"
                  />
                )}
              </Box>
              <Typography fontWeight={600} mt={3}>
                {
                  Object.values(ProductVariantPlotMapCategory).find(
                    (category) =>
                      category.key === variant.customFields?.category
                  )?.label
                }
              </Typography>
              <Typography mt={1}>{variant.description || '-'}</Typography>
            </Stack>
          ))}
        </>
      )}
    </Box>
  );
}
